/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetUserRewardsResult } from '../../models/get-user-rewards-result';

export interface GetUserRewards$Params {
  SiteName?: string;
}

export function getUserRewards(
  http: HttpClient,
  rootUrl: string,
  params?: GetUserRewards$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<GetUserRewardsResult>> {
  const rb = new RequestBuilder(rootUrl, getUserRewards.PATH, 'get');
  if (params) {
    rb.query('SiteName', params.SiteName, {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetUserRewardsResult>;
    }),
  );
}

getUserRewards.PATH = '/Loyalty/user-rewards';
